import React, { Component } from 'react';
import Layout from '../components/Layout/Layout';
import AuthenticatorRecoveryForm from '../components/Login/components/AuthenticatorRecoveryForm';

export default class AuthenticatorRecovery extends Component {
  render() {
    return (
      <Layout>
        <AuthenticatorRecoveryForm {...this.props} />
      </Layout>
    );
  }
}
